import { IActivityNavItem } from '../common/activity_nav/interface'
import { IGetGroupActivityListRes } from '../activity_rank/interface'

class Format {
    public static groupActivityListToActivityNav(GgoupActivityList: IGetGroupActivityListRes, groupId: number): IActivityNavItem[] {
        const activityNavList: IActivityNavItem[] = []
        Array.isArray(GgoupActivityList.list) && GgoupActivityList.list.forEach(item => {
            activityNavList.push({
                key: item.id,
                name: item.name,
                href: `/comments/${groupId}/detail/${item.id}`
            })
        })
        return activityNavList
    }
}

export {
    Format
}


// WEBPACK FOOTER //
// ./src/components/activity_comment/helper.ts